import React, {Component} from 'react';
import {connect} from 'react-redux';
import SliderAllNewsContainer from "./containers/sliderallnewscontainer.component";
import GroupedNews from "./groupednews.component";
import CinemapCard from "../../../SHARED/components/card/card.component";
import SearchByTag from "../../../SHARED/components/searchbytag/searchbytag.component";
import PortretNewsContainer from "./containers/portretnewscontainer.component";
import {
    getLastNewsFromAllCategories,
    getNewsFromCategory,
    getNewsFromCategorySeeMore
} from '../../../SHARED/actions/news.actions';
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import {API_URL} from '../../../SHARED/config/apiEndpoints';
import CustomNews from "../customnews/customnews.component";
import Ads from "../ads/ads.component";
import postscribe from "postscribe";
import { Helmet } from 'react-helmet';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
class GeneralNews extends Component {

    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.getLastNewsFromAllCategories();
        const payload = {
            newsCategory: this.props.match.params.newsCategory,
            page: 0
        };
        this.props.getNewsFromCategory(payload);
    }

    componentDidMount() {
        // this.getStarWarsAd();
        pageViewEvent(this.props.news.rows && `${this.props.news.rows[0].article_category === 'Știri' ? 'Știri - ' : this.props.news.rows[0].article_category + ' - Știri - '}`+'Cinemap',window.location.href)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            // this.getStarWarsAd();
            window.scrollTo(0, 0);
            const payload = {
                newsCategory: nextProps.match.params.newsCategory,
                page: 0
            };
            this.props.getNewsFromCategory(payload);
            pageViewEvent(nextProps.news.rows && `${nextProps.news.rows[0].article_category === 'Știri' ? 'Știri - ' : nextProps.news.rows[0].article_category + ' - Știri - '}`+'Cinemap',window.location.href)
        }
    }

    getLatestNews = () => {
        return this.props.newsFromCategs.map((nw, i) => {
            return <GroupedNews nw={nw} key={i}/>
        });
    };

    getCards = () => {
        if (this.props.news.rows) {
            return this.props.news.rows.map((card, i) => {
                return (
                    <div className="editorial-news-for-you recommended-for-you cinemapcard col-lg-4" key={i}>
                        {/*<CinemapCard
                            id={card.article_id}
                            headline={card.article_category}
                            image={API_URL + card.article_image}
                            title={card.article_title}
                            color={card.category_color}
                            description={card.article_summary}
                        />*/}
                        <CustomNews
                            id={card.article_id}
                            image={API_URL + card.article_image}
                            title={card.article_title}
                            date={card.article_created}
                            color={card.category_color}
                            headline={card.article_category}
                            description={card.article_summary}
                        />
                    </div>
                );
            });
        }
    };

    seeMore = () => {
        const payload = {
            newsCategory: this.props.match.params.newsCategory,
            page: this.props.news.pager.current_page + 1
        }
        this.props.getNewsFromCategorySeeMore(payload);
    }

    getSeeMoreCondition = () => {
        if (this.props.news) {
            if (this.props.news.rows && this.props.news.pager) {
                return <span className="see-more" onClick={this.seeMore}>
                    {this.props.news.rows.length !== this.props.news.pager.total_items ? "Vezi mai multe..." : ""}
                </span>
            }
        }
    }

    getStarWarsAd() {
        // if (this.props.history.location.pathname === '/stiri/star-wars') {
            return (
                window.innerWidth > 1350 ? 
                    <Ads
                        id="div-gpt-ad-1662463178982-0"
                        slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463178982-0'); googletag.pubads().refresh();});"
                    /> : 
                    <Ads
                        id="div-gpt-ad-1662463706379-0"
                        slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463706379-0'); googletag.pubads().refresh();});"
                    />
                    
            );
            // postscribe('#ads-star-wars',
            //     '<script async src=\'https://www.googletagservices.com/tag/js/gpt.js?test='+ Math.random() +'\'>\n' +
            //         'googletag.pubads().definePassback(\'/95005615/billboard_cinemap_sw\', [970, 250]).display();\n' +
            //     '</script>');
        }
    // }

    render() {
        return (
            <div className="editorial-news pt-2">
                {this.props.loading !== 0 ? <Spinner/> : ''}
                <Helmet>
                    <title>{this.props.news.rows && `${this.props.news.rows[0].article_category === 'Știri' ? 'Știri - ' : this.props.news.rows[0].article_category + ' - Știri - '}`+'Cinemap'}</title>
                    <meta name='description' content={'Citește ultimele știri de pe Cinemap. Articole, '+ (this.props.news.rows && this.props.news.rows[0].article_category && `${this.props.news.rows[0].article_category}, `)+'Informații și mai multe.'}/>
                    <link rel='canonical' href={window.location.href}/>
                </Helmet>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-9">
                            {this.getStarWarsAd()}
                            <div className="row">
                                {this.getCards()}
                            </div>
                            {this.getSeeMoreCondition()}
                            {this.getLatestNews()}
                        </div>
                        <div className="col-lg-3">
                            <PortretNewsContainer/>
                            <SearchByTag/>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    newsFromCategs: state.news.newsFromCategs,
    news: state.news.newsCateg
});
export default connect(mapStateToProps, {
    getLastNewsFromAllCategories,
    getNewsFromCategory,
    getNewsFromCategorySeeMore
})(GeneralNews);



// WEBPACK FOOTER //
// ./src/FO/components/news/generalnews.component.js